(() => {
  const bindDrawer = (root) => {
    const dialog =
      root.parentElement?.querySelector('dialog.aurora-drawer') ||
      (root.nextElementSibling?.matches?.('dialog.aurora-drawer') && root.nextElementSibling) ||
      document.querySelector('dialog.aurora-drawer');
    if (!dialog) return;

    const tabs = dialog.querySelectorAll('[data-aurora-tab]');
    const panes = dialog.querySelectorAll('[data-aurora-pane]');

    const openTab = (key) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.auroraTab === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panes.forEach((pane) => {
        pane.classList.toggle('is-active', pane.dataset.auroraPane === key);
      });
    };

    const openDrawer = (key) => {
      openTab(key);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('aurora-drawer-open');
    };

    const closeDrawer = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('aurora-drawer-open');
    };

    root.querySelectorAll('[data-aurora-drawer-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.hasAttribute('disabled')) return;
        openDrawer(btn.dataset.auroraDrawerOpen);
      });
    });

    dialog.querySelectorAll('[data-aurora-drawer-close]').forEach((btn) => {
      btn.addEventListener('click', closeDrawer);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDrawer();
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('aurora-drawer-open');
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => openTab(tab.dataset.auroraTab));
    });
  };

  const bindTrustIcons = (root) => {
    const trust = root.querySelector('[data-aurora-trust]');
    if (!trust) return;

    const reveal = () => {
      trust.classList.remove('is-visible');
      void trust.offsetWidth;
      trust.classList.add('is-visible');
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      trust.classList.add('is-visible');
      return;
    }

    const inView = () => {
      const rect = trust.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.9 && rect.bottom > 0;
    };

    if (inView()) {
      // Defer one frame so first paint can include undrawn icons
      requestAnimationFrame(reveal);
    }

    if (!('IntersectionObserver' in window)) {
      if (!trust.classList.contains('is-visible')) reveal();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) reveal();
        }
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );
    observer.observe(trust);
  };

  const bindOffers = (root) => {
    const form = root.querySelector('[data-aurora-offer-form], .aurora-pdp__form');
    const variantInput = root.querySelector('[data-aurora-variant-id], .product-variant-id');
    const offers = root.querySelectorAll('[data-aurora-offer]');
    if (!form || !variantInput || !offers.length) return;

    const priceEl = root.querySelector('[data-aurora-price]');
    const compareEl = root.querySelector('[data-aurora-compare]');
    const installmentEls = root.querySelectorAll('[data-aurora-installment], [data-aurora-installment-2]');
    const atc = root.querySelector('[data-aurora-atc]');
    const atcPrice = root.querySelector('[data-aurora-atc-price]');

    const selectOffer = (offer) => {
      if (!offer || offer.dataset.available === 'false') return;

      offers.forEach((item) => {
        const active = item === offer;
        item.classList.toggle('is-selected', active);
        const input = item.querySelector('[data-aurora-offer-input]');
        if (input) input.checked = active;
      });

      const variantId = offer.dataset.variantId;
      const price = offer.dataset.price || '';
      const compare = offer.dataset.compare || '';
      const installment = offer.dataset.installment || '';
      const available = offer.dataset.available !== 'false';

      variantInput.value = variantId;
      if (priceEl) priceEl.textContent = price;
      if (compareEl) {
        compareEl.textContent = compare;
        compareEl.classList.toggle('is-hidden', !compare);
      }
      installmentEls.forEach((el) => {
        el.textContent = installment;
      });
      if (atcPrice) atcPrice.textContent = price;
      if (atc) atc.disabled = !available;

      const stickyPrice = document.querySelector('.sticky-add-to-cart__aurora-price');
      if (stickyPrice && price) stickyPrice.textContent = price;
      const sticky = document.querySelector('sticky-add-to-cart');
      if (sticky && variantId) sticky.dataset.currentVariantId = variantId;

      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      form.dispatchEvent(
        new CustomEvent('aurora:variant-change', {
          bubbles: true,
          detail: { variantId, price, compare, installment, available },
        })
      );
    };

    offers.forEach((offer) => {
      offer.addEventListener('click', (event) => {
        event.preventDefault();
        selectOffer(offer);
      });
      const input = offer.querySelector('[data-aurora-offer-input]');
      if (input) {
        input.addEventListener('change', () => {
          if (input.checked) selectOffer(offer);
        });
      }
    });
  };

  document.querySelectorAll('.aurora-pdp').forEach((root) => {
    bindDrawer(root);
    bindTrustIcons(root);
    bindOffers(root);
  });
})();
